/**
 * #2022 Phase 4 — match a scanned shelf-tag value against a product's CodeNbr.
 *
 * The MSI/Plessey decoder (#1872) returns the raw shelf-tag digits, which are
 * assumed to equal the per-retailer CodeNbr. A physical tag (or the decode) may
 * carry leading zeros the stored code omits (or vice-versa), so compare both the
 * trimmed value and its leading-zero-stripped form. Empty stored codes never
 * match.
 */
export function codeNbrMatches(storedCodeNbr: string | null | undefined, scanned: string): boolean {
  const stored = (storedCodeNbr ?? '').trim();
  const target = scanned.trim();
  if (stored === '' || target === '') return false;
  if (stored === target) return true;
  return stored.replace(/^0+/, '') === target.replace(/^0+/, '');
}
